module.exports = __webpack_public_path__ + "img/lock.e5601f28.png";